<div class="row justify-content-center">
  <div class="col-9 border rounded mt-5 mb-5" [formGroup]="form">
    <div class="row mt-3">
      <div class="col-md-12">
        <h4 class="text-cust-blue" translate>profile_menu</h4>
      </div>
    </div>

    <div class="row mt-3" *ngIf="isCompany">
      <div class="col-3 text-right">
        <label class="required" translate>CompanyName</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control" formControlName="dpa_companyname">
        <span class="text-danger"
          *ngIf="submitted && (formControl.dpa_companyname.value == null || formControl.dpa_companyname.value.trim().length == 0) && formControl.dpa_companyname.errors?.required">
          <label translate>Please specify</label> <label translate>CompanyName</label>
          <!-- กรุณาระบุ ชื่อนิติบุคคล -->
        </span>
      </div>
      <div class="col-3 text-right">
        <label class="" translate>Regis Tax no.</label><label>/</label>
        <label class="" translate>RegisCompanyId</label>
      </div>
      <div class="col-3" *ngIf="contact == null || contact.dpa_passport == null || contact.dpa_passport.trim() == ''">
        <input type="text" class="form-control" formControlName="dpa_registrationid" readonly>
        <span class="text-danger"
          *ngIf="submitted && (formControl.dpa_registrationid.value == null || formControl.dpa_registrationid.value.trim().length == 0) && formControl.dpa_registrationid.errors?.required">
          <label translate>Please specify</label> <label class="" translate>Regis Tax no.</label><label>/</label>
          <label class="" translate>RegisCompanyId</label>
          <!-- กรุณาระบุ เลขประจำตัวผู้เสียภาษี/เลขนิติบุคคล -->
        </span>
      </div>
    </div>

    <div class="row mt-3" *ngIf="isCompany">
      <div class="col-3 text-right">
        <label class="required" translate>Account no.</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control" maxlength="13" formControlName="dpa_accountno" (keypress)="numberOnly($event)">
        <span class="text-danger"
          *ngIf="submitted && (formControl.dpa_accountno.value == null || formControl.dpa_accountno.value.trim().length == 0) && formControl.dpa_accountno.errors?.required">
          <label translate>Please specify</label> <label translate>Account no.</label>
          <!-- กรุณาระบุ เลขที่บัญชี -->
        </span>
      </div>
      <div class="col-3 text-right">
        <label class="required" translate>RegisterE-mail</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control" formControlName="emailaddress1" readonly>
        <span class="text-danger"
          *ngIf="submitted && (formControl.emailaddress1.value ==null || formControl.emailaddress1.value.trim().length == 0)">
          <label translate>Please specify</label> <label translate>RegisterE-mail</label>
          <!-- กรุณาระบุ Email หลัก -->
        </span>
        <span class="text-danger"
          *ngIf="form.get('emailaddress1').invalid && (form.get('emailaddress1').dirty || form.get('emailaddress1').touched)">
          <label translate>emailInvalid</label>
          <!-- Email หลักไม่ถูกต้อง -->
        </span>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-3 text-right">
        <label class="required" *ngIf="!isCompany" translate>Name</label>
        <label class="required" *ngIf="isCompany" translate>Attorney-in-fact's name</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control" formControlName="firstname">
        <span class="text-danger"
          *ngIf="submitted && (formControl.firstname.value == null || formControl.firstname.value.trim().length == 0) && formControl.firstname.errors?.required">
          <label translate>Please specify</label> <label translate>Name</label>
          <!-- กรุณาระบุ ชื่อ -->
        </span>
      </div>
      <div class="col-3 text-right">
        <label class="required" *ngIf="!isCompany" translate>Surname</label>
        <label class="required" *ngIf="isCompany" translate>Attorney-in-fact's surname</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control" formControlName="lastname">
        <span class="text-danger"
          *ngIf="submitted && (formControl.lastname.value == null || formControl.lastname.value.trim().length == 0) && formControl.lastname.errors?.required">
          <label translate>Please specify</label> <label translate>Surname</label>
          <!-- กรุณาระบุ นามสกุล -->
        </span>
      </div>
    </div>

    <div class="row mt-3" *ngIf="!isCompany">
      <div class="col-3 text-right">
        <label class="" translate>Date of Birth</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control" data-provide="datepicker" data-date-language="th-th" id="dob">
      </div>
      <div class="col-3 text-right">
        <label class="" translate *ngIf="!isForeign">ID no.</label><label *ngIf="!isForeign">/</label>
        <label class="required" translate *ngIf="!isForeign">Regis Tax no.</label>
        <label class="" translate *ngIf="isForeign">Passport no.</label>
      </div>
      <div class="col-3" *ngIf="!isForeign">
        <input type="text" class="form-control" formControlName="dpa_idcard" readonly>
        <span class="text-danger"
          *ngIf="submitted && (formControl.dpa_idcard.value == null || formControl.dpa_idcard.value.trim().length == 0) && formControl.dpa_idcard.errors?.required">
          <label translate>Please specify</label> <label translate>ID no.</label>/<label translate>Regis Tax no.</label>
          <!-- กรุณาระบุ เลขบัตรประชาชน/เลขประจำตัวผู้เสียภาษี -->
        </span>
      </div>
      <div class="col-3" *ngIf="isForeign">
        <input type="text" class="form-control" formControlName="dpa_passport" readonly>
      </div>
    </div>

    <div class="row mt-3" *ngIf="isCompany">
      <div class="col-3 text-right">
        <label class="" translate>ID no.</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control" formControlName="dpa_authorizedperson_idcard">
        <span class="text-danger"
          *ngIf="submitted && (formControl.dpa_authorizedperson_idcard.value == null || formControl.dpa_authorizedperson_idcard.value.trim().length == 0) && formControl.dpa_authorizedperson_idcard.errors?.required">
          <label translate>Please specify</label> <label translate>ID no.</label>
          <!-- กรุณาระบุ เลขบัตรประชาชน -->
        </span>
      </div>
      <div class="col-3 text-right">
        <label class="required" translate>Regis Phone no.</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control" formControlName="dpa_authorizedperson_telephone"
          (keypress)="telephoneOnly($event)">
        <span class="text-danger"
          *ngIf="submitted && (formControl.dpa_authorizedperson_telephone.value == null || formControl.dpa_authorizedperson_telephone.value.trim().length == 0) && formControl.dpa_authorizedperson_telephone.errors?.required">
          <label translate>Please specify</label> <label translate>Regis Phone no.</label>
          <!-- กรุณาระบุ หมายเลขโทรศัพท์ -->
        </span>
      </div>
    </div>

    <div class="row mt-3" *ngIf="!isCompany">
      <div class="col-3 text-right">
        <label class="required" translate>Account no.</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control" maxlength="13" formControlName="dpa_accountno" (keypress)="numberOnly($event)">
        <span class="text-danger"
          *ngIf="submitted && (formControl.dpa_accountno.value == null || formControl.dpa_accountno.value.trim().length == 0) && formControl.dpa_accountno.errors?.required">
          <label translate>Please specify</label> <label translate>Account no.</label>
          <!-- กรุณาระบุ เลขที่บัญชี -->
        </span>
      </div>
      <div class="col-3 text-right">
        <label class="required" translate>RegisterE-mail</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control" formControlName="emailaddress1">
        <span class="text-danger"
          *ngIf="submitted && (formControl.emailaddress1.value ==null || formControl.emailaddress1.value.trim().length == 0)">
          <label translate>Please specify</label> <label translate>RegisterE-mail</label>
          <!-- กรุณาระบุช่อง Email หลัก -->
        </span>
        <span class="text-danger"
          *ngIf="form.get('emailaddress1').invalid && (form.get('emailaddress1').dirty || form.get('emailaddress1').touched)">
          <label translate>emailInvalid</label>
          <!-- Email หลักไม่ถูกต้อง -->
        </span>
      </div>
    </div>

    <div class="row mt-3" *ngIf="!isCompany">
      <div class="col-3 text-right">
        <label class="required" translate>Regis Phone no.</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control" formControlName="telephone1" (keypress)="telephoneOnly($event)">
        <span class="text-danger"
          *ngIf="submitted && (formControl.telephone1.value == null || formControl.telephone1.value.trim().length == 0) && formControl.telephone1.errors?.required">
          <label translate>Please specify</label> <label translate>Regis Phone no.</label>
              <!-- กรุณาระบุ หมายเลขโทรศัพท์ -->
        </span>
      </div>
    </div>

    <hr>

    <!-- <div class="row mt-3">
      <div class="col-md-12 text-center">
        <h4 class="text-cust-blue">Facebook</h4>
      </div>
    </div>

    <div class="row mt-3" *ngIf="!isCompany">
      <div class="col-6 text-right">
        <button class="btn btn-primary btn-fb">
          <span class="fab fa-facebook-f"></span>
          Facebook login
        </button>
      </div>
      <div class="col-6 text-center">เชื่อมต่อ Facebook แล้ว</div>
    </div>

    <hr *ngIf="!isCompany">

    <div class="row mt-3">
      <div class="col-md-12 text-center">
        <h4 class="text-cust-blue">Google</h4>
      </div>
    </div>
    <div class="row mt-3" *ngIf="!isCompany">
      <div class="col-6 text-right">
        <button class="btn btn-danger btn-gg">
          <span class="fab fa-google-plus-g"></span>
          Google+ login
        </button>
      </div>
      <div class="col-6 text-center">เชื่อมต่อ Google+ แล้ว</div>
    </div>

    <hr *ngIf="!isCompany">
    <div class="row mt-3">
      <div class="col-md-12 text-center">
        <h4 class="text-cust-blue">Line</h4>
      </div>
    </div>

    <div class="row mt-3" *ngIf="!isCompany">
      <div class="col-6 text-right">
        <button class="btn btn-success btn-ln">
          <span class="fab fa-line"></span>
          Line login
        </button>
      </div>
      <div class="col-6 text-center">เชื่อมต่อ Line แล้ว</div>
    </div>

    <hr *ngIf="!isCompany"> -->
    <div class="row mt-3">
      <div class="col-md-12 text-left">
        <h4 class="text-cust-blue" translate>Contact Address</h4>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-3 text-right">
        <label class="required" translate>Address</label>
      </div>
      <div class="col-9">
        <input type="text" class="form-control" formControlName="dpa_contact_homeno">
        <span class="text-danger"
          *ngIf="submitted && (formControl.dpa_contact_homeno.value == null || formControl.dpa_contact_homeno.value.trim().length == 0) && formControl.dpa_contact_homeno.errors?.required">
          <label translate>Please specify</label> <label translate>Address</label>
          <!-- กรุณาระบุ ที่อยู่ -->
        </span>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-3 text-right">
        <label class="" translate>Moo</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control" formControlName="dpa_contact_moo" maxlength="100">
      </div>
      <div class="col-3 text-right">
        <label class="" translate>Street</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control" formControlName="dpa_contact_street">
      </div>
    </div>
    
    <div class="row mt-3 select2-th">
      <div class="col-md-3 text-right">
        <label translate>Select Location</label>
      </div>
      <div class="col-md-9">
        <select class="form-control select2 select2th">
          <option value="" translate>Select</option>
          <option *ngFor="let sd of combinedAddressList" [value]="sd.id">
            {{sd.text}}
          </option>
        </select>
      </div>
    </div>

    <div class="row mt-3 select2-en">
      <div class="col-md-3 text-right">
        <label translate>Select Location</label>
      </div>
      <div class="col-md-9">
        <select class="form-control select2 select2en">
          <option value="" translate>Select</option>
          <option *ngFor="let sd of combinedAddressListEn" [value]="sd.id">
            {{sd.text_eng}}
          </option>
        </select>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-3 text-right">
        <label translate>Sub-district</label>
      </div>
      <div class="col-md-3">
        <input type="text" class="form-control" formControlName="dpa_contact_subdistictname" readonly>
      </div>
      <div class="col-md-3 text-right">
        <label translate>District</label>
      </div>
      <div class="col-md-3">
        <input type="text" class="form-control" formControlName="dpa_contact_distictname" readonly>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-3 text-right">
        <label translate>Province</label>
      </div>
      <div class="col-md-3">
        <input type="text" class="form-control" formControlName="dpa_contact_provincname" readonly>
      </div>
      <div class="col-md-3 text-right">
        <label translate>Postal code</label>
      </div>
      <div class="col-md-3">
        <input type="text" class="form-control" formControlName="dpa_contact_postcodename" readonly>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-3 text-right">
        <label translate>Country</label>
      </div>
      <div class="col-md-3">
        <input type="text" class="form-control" formControlName="dpa_contact_countryname" readonly>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-3">
      </div>
      <div class="col-9">
        <div class="row">
          <div class="col-12 mt-3 mb-2 text-left ml-3 sr-only">
            <label translate>
              <input type="checkbox" [checked]="allowNews" (change)="newsAllowChange($event.target)" >
              Would you like to receive notifications on the latest updates from the DPA?
            </label>
          </div>
          <div class="col-12 mt-2mb-2 text-left ml-3">
            <label translate>
              <input type="checkbox" (change)="consentAcceptChange($event.target)">
              Agree <!-- <button class="btn btn-link" (click)="showConsent()"></button> -->
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4 mb-4">
      <div class="col-12 text-center">
        <button class="btn btn-default mr-2" [disabled]="!isConsentAccept" (click)="save()" translate>Save</button>
        <button class="btn btn-default ml-2" (click)="close()" translate>Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Forward-->
<div class="modal fade" id="consentModal" tabindex="-1" role="dialog" aria-labelledby="consentModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="consentModalLabel">นโยบายความเป็นส่วนตัว (Privacy Policy)</h5>
      </div>
      <div class="modal-body">

        <div class="row border rounded">
          <div class="col-12 text-center">
            <h4 style="padding-top: 10px;">นโยบายความเป็นส่วนตัว (Privacy Policy)</h4>
          </div>
          
          <div class="row">
            <div class="col-12" id="proPolicy">
                <!--  <p><span style="font-size:16px">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;สถาบันคุ้มครองเงินฝาก (สคฝ.) เป็นหน่วยงานของรัฐ จัดตั้งขึ้นตามพระราชบัญญัติสถาบันคุ้มครองเงินฝาก พ.ศ.2551 ยึดมั่นการดำเนินงานตามหลักบรรษัทภิบาลในการปฏิบัติงานอย่างเคร่งครัด สคฝ. ขอขอบคุณสำหรับความไว้วางใจจากท่าน และตระหนักดีว่าท่านต้องการความปลอดภัยในการทำธุรกรรม และการรักษาข้อมูลส่วนบุคคล</span></p>
  
  <p><span style="font-size:16px">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;สคฝ. จึงได้กำหนดนโยบายความเป็นส่วนตัว (Privacy Policy) เพื่อให้ท่านมั่นใจเรื่องการคุ้มครองข้อมูลส่วนบุคคล การเก็บรักษาข้อมูลไว้เป็นความลับ รวมทั้งการเปิดเผยหรือการนำไปใช้ที่ต้องเป็นไปด้วยความรอบคอบ และคำนึงถึงความปลอดภัยของข้อมูลเป็นสำคัญ โดยท่านสามารถศึกษารายละเอียดของนโยบายความเป็นส่วนตัว (Privacy Policy) ได้ (เป็น share link file)</span></p>
  
  <p>&nbsp;</p>
  
  <p><span style="font-size:16px">ขอแสดงความนับถือ</span></p>
  
  <p><span style="font-size:16px">สถาบันคุ้มครองเงินฝาก</span></p>-->
            </div>
        </div>
         <!-- <div class="col-12 mt-3">
            <label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; สถาบันคุ้มครองเงินฝาก (สคฝ.) เป็นหน่วยงานของรัฐ
              จัดตั้งขึ้นตามพระราชบัญญัติสถาบันคุ้มครองเงินฝาก พ.ศ. 2551
              ยึดมั่นการดำเนินงานตามหลักบรรษัทภิบาลในการปฏิบัติงานอย่างเคร่งครัด สคฝ. ขอขอบคุณสำหรับความไว้วางใจจากท่าน
              และตระหนักดีว่าท่านต้องการความปลอดภัยในการทำธุรกรรม และการรักษาข้อมูลส่วนบุคคล</label>
            <br>
            <label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; สคฝ. จึงได้กำหนดนโยบายความเป็นส่วนตัว (Privacy Policy)
              เพื่อให้ท่านมั่นใจเรื่องการคุ้มครองข้อมูลส่วนบุคคล การเก็บรักษาข้อมูลไว้เป็นความลับ
              รวมทั้งการเปิดเผยหรือการนำไปใช้ที่ต้องเป็นไปด้วยความรอบคอบ และคำนึงถึงความปลอดภัยของข้อมูลเป็นสำคัญ
              โดยท่านสามารถศึกษารายละเอียดของนโยบายความเป็นส่วนตัว (Privacy Policy)</label>
          </div>
          <div class="col-12 mt-3">
            <label>ขอแสดงความนับถือ</label>
          </div>
          <div class="col-12">
            <label>สถาบันคุ้มครองเงินฝาก</label>
          </div>-->

          <div class="col-12 text-center mt-3 mb-2">
            <button type="button" class="btn btn-info ml-2" data-dismiss="modal">ปิด</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/profile/profile.component.html